import { render, staticRenderFns } from "./banners-table.vue?vue&type=template&id=3265b597&scoped=true"
import script from "./banners-table.vue?vue&type=script&lang=js"
export * from "./banners-table.vue?vue&type=script&lang=js"
import style0 from "./banners-table.vue?vue&type=style&index=0&id=3265b597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3265b597",
  null
  
)

export default component.exports